import React, { useEffect, useState } from 'react';

import {
  Alert, Skeleton, Stack, Typography,
} from '@mui/material';

import ContentCard from '../../../../components/ContentCard';
import { Exam } from '../../../../services/exams/types';
import { QuestionType } from '../../../../types/common';
import { AlertContainer } from '../../index.styles';

interface SummaryCardProps {
  exam?: Exam
}

const SummaryCard = ({ exam }: SummaryCardProps) => {
  // Multiple Choice tally
  const [mcqCount, setMcqCount] = useState<number>(0);
  const [mcqTotal, setMcqTotal] = useState<number>(0);
  // Written Responses tally
  const [wrCount, setWrCount] = useState<number>(0);
  const [wrTotal, setWrTotal] = useState<number>(0);

  // Tally marks
  useEffect(() => {
    const questions = exam?.questions || [];
    if (questions) {
      const mcqList: string[] = [];
      let mcqTotalTally = 0;
      const wrList: string[] = [];
      let wrTotalTally = 0;
      questions.forEach((q) => {
        const rootQuestion = q.label.split('#')[0];
        if (q.type === QuestionType.MultipleChoice) {
          if (!mcqList.includes(rootQuestion)) mcqList.push(rootQuestion);
          mcqTotalTally += q.maxMark;
        } else {
          if (!wrList.includes(rootQuestion)) wrList.push(rootQuestion);
          wrTotalTally += q.maxMark;
        }
      });
      setMcqCount(mcqList.length);
      setMcqTotal(mcqTotalTally);
      setWrCount(wrList.length);
      setWrTotal(wrTotalTally);
    }
  }, [exam]);

  if (!exam) {
    return (
      <Skeleton variant="rectangular" height={128} />
    );
  }

  return (
    <ContentCard variant="outlined" title="Questions Summary">
      {(mcqCount > 0 || wrCount > 0) ? (
        <Stack>
          <AlertContainer>
            <Alert severity="warning">
              Please check that the exam has the correct number
              of marks in total during entry.
            </Alert>
          </AlertContainer>
          <Typography variant="body1">
            Total: {mcqTotal + wrTotal} mark{mcqTotal + wrTotal > 1 ? 's' : ''}<br />
            {mcqCount > 0 && (
              <>Multiple Choice: {mcqCount} Questions ({mcqTotal} mark{mcqTotal > 1 ? 's' : ''})<br /></>
            )}
            {wrCount > 0 && (
              <>Written Response: {wrCount} Questions ({wrTotal} mark{wrTotal > 1 ? 's' : ''})<br /></>
            )}
          </Typography>
        </Stack>
      ) : (
        <Typography variant="overline">
          No Questions Added Yet
        </Typography>
      )}
    </ContentCard>
  );
};

export default SummaryCard;
